module.exports = __webpack_public_path__ + "img/hoteles-bg.95d33e19.jpg";